import demandService from '@/service/demand';
import { toggleValue } from '@/store';
import localforage from 'localforage';
import { isEmpty } from 'lodash';
import { observable, action, runInAction } from 'mobx';
import { changeCityActive, changeCityType, getCityList, getCityOption, getCityTimeList } from './city';
import { changeCompanyActive, changeCompanyRankActive, changeCompanyRankType, changeCompanyType, changeInitTime1, getCompanyIndustryTime, getCompanyRankList, getCompanyRankTime, getConapanyIndustry, getTimeList } from './company';
import { changeQuantityType, changex, changey, getRankTop10, getRankTop30, getTimeListTop } from './hotrole';
import { getHotIndustry, getTrendYear, getTrendMonth, getTrendQuarter, getIndustryTrend, changeHotType, changeHotActive, changeTrendType, changeTrendActive } from './industry';
import { changeRoleType, changeSubRoleList, getCategoryList, getChartList } from './role';


// 获取人均福利分布

const moDemand = observable({
});


const demandInit = action(async () => {
  const local: any = await localforage.getItem('demand') || {};
  changeHotType(local['industryType'] || "chart")
  changeHotActive(local['industryActive'] || "hot")
  changeTrendType(local['trendType'] || "chart")
  changeTrendActive(local['trendActive'] || "year")
  changeCompanyActive(local['companyActive'] || "industry")
  changeCompanyType(local['companyType'] || "chart")
  changeInitTime1(local['companyActiveTime1'] || "年度")
  changeCompanyRankType(local['companyRankType'] || "chart")
  changeCompanyRankActive(local['companyRankActive'] || "num")
  changeCityType(local['cityType'] || "chart")
  changeCityActive(local['cityActive'] || "num")
  changeRoleType(local['roleType'] || "chart")
  changeSubRoleList(['全部', '全部'])
  changeQuantityType(local['quantityType'] || "chart")
  changex(local['Xvlaue'] || "axis_amount")
  changey(local['Yvlaue'] || "axis_amount_change")
  await Promise.all([
    getCompanyRankTime(), getTimeList(), getCityTimeList(), getCategoryList(), getCityOption(), getTimeListTop()
  ])
  await Promise.all([
    getHotIndustry(), getIndustryTrend(), getTrendYear(), getTrendMonth(), getTrendQuarter(), getConapanyIndustry(),
    getCompanyIndustryTime(), getCompanyRankList(), getCityList(), getChartList(), getRankTop10(), getRankTop30()
  ]);
});

export default moDemand;
export { demandInit }
